import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PeopleBubbleChartPage from './pages/PeopleBubbleChartPage.js';
import EntityTripleGraphPage from './pages/EntityTripleGraphPage.js';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Test from './Test.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Test />} />
        <Route path="/graph/:dbName" element={<App />}></Route>
        <Route
          path="/personbubble/:dbName"
          element={<PeopleBubbleChartPage />}
        />
        <Route
          path="/entityTripleGraph/:dbName/:entity"
          element={<EntityTripleGraphPage />}
        />

        <Route path="/demo/graph" element={<App isDemo={true} />} />
        <Route
          path="/demo/personbubble"
          element={<PeopleBubbleChartPage isDemo={true} />}
        />
        <Route
          path="/demo/entityTripleGraph"
          element={<EntityTripleGraphPage isDemo={true} />}
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
